import React from "react"

type Props = {
  activeTab: string | null
  controlName: string
  label: string
  onClick: () => void
  controller?: JSX.Element
  ref?: Object
  tabId?: number | string
}

import * as s from "./Tab.module.scss"

const Tab = ({ activeTab, label, onClick, tabId, controlName }: Props) => {
  const activeTabClass =
    activeTab === tabId
      ? `${s.Tab__listItem___active}`
      : `${s.Tab__listItem___inActive}`

  return (
    <button 
      id={`${controlName}-tab-${tabId}`}
      type="button" 
      role="tab" 
      aria-selected={activeTab === tabId ? 'true' : 'false'} 
      aria-controls={`${controlName}-tabpanel-${tabId}`}
      onClick={onClick}
      key={tabId}
      className={`${s.Tab__listItem} ${activeTabClass}`}
    >
      <span>{label}</span>
    </button>
  )
}

export default Tab
